<!-- Right Sidebar -->

<div class="right-bar">

  <ngx-simplebar class="h-100">
    <ng-container *ngIf="content">
      <ng-container [ngComponentOutlet]="content"></ng-container>
    </ng-container>
  </ngx-simplebar>
</div>
<!-- /Right-bar -->

<!-- Right bar overlay -->
<div class="rightbar-overlay" (click)="onOverlayClick()"></div>